import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TimelineFilterEditor from './TimelineFilterEditor';

const TimelineFilter = ({ rows, isOpen, filterRoles, onPresentFilters, onClose }) => {
    // LOCAL STATE
    const [isTimelineFilterOpen, setIsTimelineFilterOpen] = useState(false);
    const timelineFilterDetails = [
        {
            id: '00000000-0000-0000-0000-000000000001',
            name: 'Appointments'
        }
    ];

    // USEEFFECTS
    useEffect(() => {
        setIsTimelineFilterOpen(isOpen);
    }, [isOpen]);

    // EVENT HANDLERS
    const onTimelineFilterClose = () => {
        setIsTimelineFilterOpen(false);
        onClose();
    };

    // RENDER
    return (
        <TimelineFilterEditor
            rows={rows}
            isOpen={isTimelineFilterOpen}
            filterRoles={filterRoles}
            onCancel={onTimelineFilterClose}
            timelineFilterDetails={timelineFilterDetails}
            onPresentFilters={onPresentFilters}
        />
    );
};

TimelineFilter.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    isOpen: PropTypes.bool,
    filterRoles: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func,
    onPresentFilters: PropTypes.func
};

export default TimelineFilter;
